import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import Dropdown from './Dropdown';
import ChevronDown from '@/images/icons/ChevronDown';
import { fetchMyProjects, setCurrentProjectId } from '@/actions';
import { DropdownContext } from '@/components/Dropdown/DropdownContext';
import ProjectAvatar from './ProjectAvatar';

function ProjectProfile({
  project,
  user,
}) {
  let navigate = useNavigate();
  let dispatch = useDispatch();

  const auth = useSelector(state => state.auth);
  const { openDropdownId } = useContext(DropdownContext);
  const isDropdownOpen = openDropdownId === `project-dropdown-${project.projectId}`;

  const myProjectIds = useSelector(state => state.project.myIds);
  const projects = useSelector(state => state.project.byId);
  const projectsCount = myProjectIds.list.length || 0;

  const onGetProjects = async () => {
    dispatch(fetchMyProjects(auth.user.token));
  };

  const button = (
    <button
      className={classNames(
        "inline-flex items-center w-full group focus:outline-0 p-3 sm:p-2.5 rounded-xl transition",
        isDropdownOpen && projectsCount > 1 && 'bg-[#F7F6F2]',
        projectsCount <= 1 && 'cursor-default'
      )}
      aria-haspopup="true"
      onClick={onGetProjects}
    >
      <ProjectAvatar className="min-w-8 w-8 h-8 rounded-full" project={project} />
      <div className="flex truncate w-full">
        <div className="ml-3 mr-2 w-[calc(100%-28px-8px)] sm:w-auto text-left">
          <div className="truncate text-sm text-left font-medium mb-0.5">{project.name}</div>
          <div className="text-[11px]/[1.1] font-medium text-[#A5A5A5] text-left">
            {project.creatorUserId === user.userId ? "Project owner" : "Team member"}
          </div>
        </div>
        {/*{projectsCount > 1 && (*/}
          <ChevronDown className={classNames(
            'min-w-4 w-4 h-4 ml-auto',
            projectsCount > 1 && isDropdownOpen && 'rotate-180',
          )} />
        {/*)}*/}
      </div>
    </button>
  );

  const changeProject = (e) => {
    dispatch(setCurrentProjectId(e.currentTarget.dataset.projectId, null));
    navigate("/");
  };

  return (
    <Dropdown
      button={button}
      id={`project-dropdown-${project.projectId}`}
      className="relative inline-flex w-full"
      top="top-[calc(100%+10px)]"
    >
      {myProjectIds.list.filter(id => id !== project.projectId).map((projectId, i) => (
        <button
          key={`project-select-${projectId}`}
          className="flex items-center py-[14px] px-3 sm:p-4 w-full text-white text-sm font-medium border-b border-b-[#313334] last:border-b-0 first:rounded-t-xl last:rounded-b-xl hover:bg-[#313334] transition"
          data-project-id={projectId}
          onClick={(e) => changeProject(e)}
        >
          <ProjectAvatar className="min-w-8 w-8 h-8 rounded-full" project={projects[projectId]} />
          <div className="flex truncate w-full">
            <div className="ml-3 mr-2 w-[calc(100%-20px)]">
              <div className="truncate text-sm text-left font-medium mb-0.5">{projects[projectId].name}</div>
              <div className="text-[11px]/[1.1] font-medium text-[#A5A5A5] text-left">
                {projects[projectId].creatorUserId === user.userId ? "Project owner" : "Team member"}
              </div>
            </div>
          </div>
        </button>
      ))}
    </Dropdown>
  )
}

export default ProjectProfile;
